module.exports = __webpack_public_path__ + "assets/adpoly-it-scrap-bulk-upload-template.265175e8.xlsx";